import { useEffect } from 'react';

export default function Modal({ open, title, message, onConfirm, onCancel, confirmText = 'Confirmar', cancelText = 'Cancelar', type = 'confirm', icon = '⚠️' }) {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  if (!open) return null;

  const colors = {
    danger:  { btn: 'linear-gradient(135deg,#ef4444,#dc2626)', shadow: 'rgba(239,68,68,0.4)',   border: 'rgba(239,68,68,0.2)'   },
    warning: { btn: 'linear-gradient(135deg,#f59e0b,#d97706)', shadow: 'rgba(245,158,11,0.4)',  border: 'rgba(245,158,11,0.2)'  },
    info:    { btn: 'linear-gradient(135deg,#7c3aed,#6d28d9)', shadow: 'rgba(124,58,237,0.4)',  border: 'rgba(124,58,237,0.2)'  },
    success: { btn: 'linear-gradient(135deg,#10b981,#059669)', shadow: 'rgba(16,185,129,0.4)',  border: 'rgba(16,185,129,0.2)'  },
  };
  const c = colors[type] || colors.info;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: 'rgba(0,0,0,0.75)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      backdropFilter: 'blur(4px)',
      animation: 'fadeInOverlay 0.15s ease',
    }}>
      <div style={{
        background: 'linear-gradient(160deg,#0e0e22,#080810)',
        border: `1px solid ${c.border}`,
        borderRadius: 16, padding: '32px 28px', width: 380, maxWidth: '90vw',
        boxShadow: `0 20px 60px rgba(0,0,0,0.5), 0 0 40px ${c.shadow}`,
        animation: 'slideUpModal 0.2s cubic-bezier(0.34,1.56,0.64,1)',
      }}>
        {/* Icon */}
        <div style={{
          width: 52, height: 52, borderRadius: 14, margin: '0 auto 20px',
          background: `linear-gradient(135deg, ${c.border}, transparent)`,
          border: `1px solid ${c.border}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 24,
        }}>{icon}</div>

        {/* Title */}
        <div style={{ fontFamily: 'Inter,sans-serif', fontSize: 18, fontWeight: 700, color: '#f1f5f9', textAlign: 'center', marginBottom: 10 }}>
          {title}
        </div>

        {/* Message */}
        <div style={{ fontSize: 13, color: '#64748b', textAlign: 'center', lineHeight: 1.6, marginBottom: 28 }}>
          {message}
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: 10 }}>
          {onCancel && (
            <button onClick={onCancel} style={{
              flex: 1, padding: '11px', borderRadius: 9,
              background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)',
              color: '#64748b', fontSize: 13, fontWeight: 500, cursor: 'pointer',
              transition: 'all 0.2s',
            }}>{cancelText}</button>
          )}
          <button onClick={onConfirm} style={{
            flex: 1, padding: '11px', borderRadius: 9, border: 'none',
            background: c.btn, color: '#fff', fontSize: 13, fontWeight: 700,
            cursor: 'pointer', transition: 'all 0.2s',
            boxShadow: `0 4px 16px ${c.shadow}`,
          }}>{confirmText}</button>
        </div>
      </div>

      <style>{`
        @keyframes fadeInOverlay { from { opacity:0; } to { opacity:1; } }
        @keyframes slideUpModal { from { opacity:0; transform:scale(0.9) translateY(20px); } to { opacity:1; transform:scale(1) translateY(0); } }
      `}</style>
    </div>
  );
}
